import React from 'react';
import { Subscribe } from 'unstated';
import { RouteComponentProps } from 'react-router-dom';
import FeatureContainer from '../../state/containers/FeatureContainer';
import NumberRangeContainer from '../../state/containers/NumberRangeContainer';
import ApplicationContainer from '../../state/containers/ApplicationContainer';
import TitleStateContainer from '../../state/containers/TitleStateContainer';
import RepromptContainer from '../../state/containers/RepromptContainer';
import FollowUpContainer from '../../state/containers/FollowUpContainer';
import CreateNumberRangeForm from './components/CreateNumberRangeForm';
import MediaResponseStateContainer from '../../state/containers/MediaResponseContainer';
import NavigationBarFormPage from '../formScenes/NavigationBarFormPage';
import ConversationNavigationState from '../../models/state/ConversationNavigationState';
import IResult from '../../models/result/IResult';
import NumberRangeModel from '../../models/features/api/NumberRanges/NumberRangeModel';
import GenericCreateContentItemPage from '../formScenes/GenericCreateContentItemPage';
import { NumberRangeFeatureTypeId } from '../../constants/featureTypeIds';
const outputIcon = require('../../content/images/device.svg');

interface ApplicationRouteProps {
    applicationFeatureId: string
}
interface CreateNumberRangeProps extends RouteComponentProps<ApplicationRouteProps> { }

class CreateNumberRange extends NavigationBarFormPage<CreateNumberRangeProps, ConversationNavigationState> {
    render() {
        return (
            <Subscribe to={[NumberRangeContainer, ApplicationContainer, TitleStateContainer, RepromptContainer, FollowUpContainer, MediaResponseStateContainer, FeatureContainer]}>
                {(numberRangeContainer: NumberRangeContainer,
                    appContainer: ApplicationContainer,
                    titleContainer: TitleStateContainer,
                    repromptContainer: RepromptContainer,
                    followUpContainer: FollowUpContainer,
                    responseStateContainer: MediaResponseStateContainer,
                    featureContainer: FeatureContainer) => {
                    return (
                        <GenericCreateContentItemPage stateContainer={numberRangeContainer}
                            titleContainer={titleContainer}
                            applicationContainer={appContainer}
                            defaultTitle="New Number Range"
                            history={this.props.history}
                            location={this.props.location}
                            match={this.props.match}
                            staticContext={this.props.staticContext}
                            featureContainer={featureContainer}
                            featureTypeId={NumberRangeFeatureTypeId}
                            formRender={(application, assistantApplication, onPublish, onSubmit: (model: NumberRangeModel) => Promise<IResult<NumberRangeModel>>, onAccessTypeChange) => (

                                <CreateNumberRangeForm
                                    location={this.props.location}
                                    applicationFeatureId={this.props.match.params.applicationFeatureId}
                                    application={application}
                                    stateContainer={numberRangeContainer}
                                    assistantApplication={assistantApplication}
                                    appContainer={appContainer}
                                    repromptContainer={repromptContainer}
                                    followUpContainer={followUpContainer}
                                    responseStateContainer={responseStateContainer}
                                    featureContainer={featureContainer}
                                    isSaving={numberRangeContainer.state.isSaving}
                                    history={this.props.history}
                                    onAccessTypeChange={onAccessTypeChange}
                                    onShowPublishModal={onPublish}
                                    onSubmit={onSubmit}
                                    onToggleNavigation={() => { }} />
                            )} />
                    );
                }}
            </Subscribe>
        );
    }
}

export default CreateNumberRange;